import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';
import { RoleType } from '@/models/enums';

class RolesHelper {
  get currentUserRole(): RoleType { return (store.getters[_act.AUTH_GET_USERROLE] || 0) as RoleType; }

  get isCurrentUserSecurityAdmin(): boolean { return this.currentUserRole === RoleType.SecurityAdmin; }

  get isCurrentUserReportsAdmin(): boolean { return this.currentUserRole === RoleType.ReportsAdministrator; }
}

export const rolesHelper: RolesHelper = new RolesHelper();
